"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _chunkB2edacfb = require("./chunk-b2edacfb.js");

var _react = _interopRequireWildcard(require("react"));

var _chunk5423f15f = require("./chunk-5423f15f.js");

require("./chunk-76875e58.js");

require("./chunk-f2932d1d.js");

require("prop-types");

require("./chunk-8219403d.js");

require("./chunk-eb19ede6.js");

require("react-dom");

require("./chunk-5ef88ed1.js");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Option = function (_Component) {
  (0, _chunkB2edacfb.f)(Option, _Component);

  function Option(props) {
    var _this;

    (0, _chunkB2edacfb.b)(this, Option);
    _this = (0, _chunkB2edacfb.d)(this, (0, _chunkB2edacfb.e)(Option).call(this, props));
    _this.onMouseEnter = _this.onMouseEnter.bind((0, _chunkB2edacfb.m)(_this));
    _this.onMouseLeave = _this.onMouseLeave.bind((0, _chunkB2edacfb.m)(_this));
    _this.state = {
      isHovering: false
    };
    return _this;
  }

  (0, _chunkB2edacfb.c)(Option, [{
    key: "onMouseEnter",
    value: function onMouseEnter() {
      this.setState({
        isHovering: true
      });
    }
  }, {
    key: "onMouseLeave",
    value: function onMouseLeave() {
      this.setState({
        isHovering: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          selectProps = _this$props.selectProps,
          label = _this$props.data.label,
          children = _this$props.children;
      var isHovering = this.state.isHovering;
      var InnerOption = selectProps.components && selectProps.components.InnerOption;
      var renderInnerOption = InnerOption ? _react.default.createElement(InnerOption, {
        isHovering: isHovering
      }, children) : children;
      return _react.default.createElement("div", {
        onMouseEnter: this.onMouseEnter,
        onMouseLeave: this.onMouseLeave,
        title: label
      }, _react.default.createElement(_chunk5423f15f.a.Option, this.props, renderInnerOption));
    }
  }]);
  return Option;
}(_react.Component);

Option.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "onMouseEnter",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "onMouseLeave",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }],
  "displayName": "Option"
};
var _default = Option;
exports.default = _default;